import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { GlobalService } from './global.service';
import { catchError, mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
// import { GlobalService } from 'src/app/services/general.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  jwtHelper = new JwtHelperService();

  constructor(
    private globalService: GlobalService,
    private authService: AuthService,
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> | Observable<any> {
    const token = this.globalService.token;

    if (token) {
      req = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(req).pipe(
      catchError((error) => {
        if (error.status == 401) {
          if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.globalService.setTokenRefresh(sessionStorage.getItem('refreshToken'));
            this.refreshTokenSubject.next(null);
            return this.authService.refreshTokens().pipe(
              mergeMap((data: any) => {
                if (data) {
                  this.isRefreshing = false;
                  this.refreshTokenSubject.next(sessionStorage.getItem('refreshToken'));
                  return next.handle(this.addToken(req, sessionStorage.getItem('refreshToken'), data?.token));
                } else {
                  this.globalService.logOut();
                }
              }),
              catchError((error) => {
                this.isRefreshing = false;
                this.globalService.logOut();
                return throwError(error);
              })
            )
          } else if (!this.jwtHelper.isTokenExpired(token)) {
            return next.handle(this.tryCall(req, sessionStorage.getItem('refreshToken')))
          }
        }
        return throwError(error);
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string, refreshToken: string) {
    sessionStorage.removeItem('refreshToken')
    sessionStorage.setItem('refreshToken', refreshToken)
    return request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        pragma: 'no-cache',
        expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
        'If-Modified-Since': '0',
        authorization: `Bearer ${token}`,
      },
    });
  }

  private tryCall(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        pragma: 'no-cache',
        expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
        'If-Modified-Since': '0',
        authorization: `Bearer ${token}`,
      },
    })
  }
}
